<ion-grid class="ion-no-padding">
    <ng-content> </ng-content>
</ion-grid>